import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["renderer"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import { renderToString } from 'react-dom/server';
import * as echarts from 'echarts';
import PropTypes from 'prop-types';
import deepmerge from 'deepmerge';
import ConfigConsumer from '@jd/jmtd/es/ConfigConsumer';
import ResizeObserver from 'resize-observer-polyfill';
import { setClass } from '@jd/jmtd-tools/es/element';
import { TOOLBOX } from '../theme/common/base';
import Tooltip from './Tooltip';
import { option } from './config';
import Chart from '../Chart';
import deepEqual from './deepEqual';

var EchartKernel = /*#__PURE__*/function (_PureComponent) {
  _inherits(EchartKernel, _PureComponent);

  var _super = _createSuper(EchartKernel);

  function EchartKernel(props) {
    var _this;

    _classCallCheck(this, EchartKernel);

    _this = _super.call(this, props);
    _this.chart = null;
    return _this;
  }

  _createClass(EchartKernel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var chartRef = this.chartRef,
          _this$props = this.props,
          renderer = _this$props.renderer,
          chartDidMount = _this$props.chartDidMount,
          chartLegendChange = _this$props.chartLegendChange;
      var chart = this.chart = echarts.init(chartRef, null, {
        renderer: renderer
      }); // 如果table尺寸变化，重新计算尺寸

      var resizeObserver = this.resizeObserver = new ResizeObserver(function () {
        chart.resize();
      });
      resizeObserver.observe(chartRef);
      this.updateChart(); // 图例全部反选，显示暂无数据

      chart.on('legendselectchanged', function (params) {
        chartLegendChange(params);

        _this2.updateEmpty(Object.keys(params.selected).filter(function (item) {
          return params.selected[item] === true;
        }).length === 0);
      }); // 暴露chart实例，便于用户拓展

      this.chartUnmount = chartDidMount(chart);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevChartConfig = _ref.chartConfig;
      var chartConfig = this.props.chartConfig;

      if (!deepEqual(chartConfig, prevChartConfig)) {
        this.updateChart();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.chart.dispose();
      this.resizeObserver.disconnect(); // 手动清除组件卸载无法清空的事件

      this.chartUnmount && this.chartUnmount();
    }
  }, {
    key: "updateEmpty",
    value: function updateEmpty(flag) {
      var chartRef = this.chartRef;
      setClass(chartRef.parentElement, 'jmtc-chart-empty', flag);
    }
  }, {
    key: "updateChart",
    value: function updateChart() {
      var chart = this.chart,
          _this$props2 = this.props,
          chartConfig = _this$props2.chartConfig,
          CustomTooltip = _this$props2.tooltipRender,
          formatter = _this$props2.formatter,
          data = _this$props2.data,
          noData = _this$props2.noData,
          isMini = _this$props2.isMini,
          showDownloadImg = _this$props2.showDownloadImg;
      var config = deepmerge({}, option);

      config.tooltip.formatter = function (params) {
        return renderToString( /*#__PURE__*/React.createElement(CustomTooltip, {
          data: data,
          params: params,
          formatter: formatter,
          isMini: isMini
        }));
      };

      chart.clear();
      var newChartConfig = deepmerge({}, chartConfig);

      if (showDownloadImg) {
        newChartConfig = _objectSpread(_objectSpread({}, TOOLBOX), chartConfig);
      }

      chart.setOption(deepmerge(config, newChartConfig));
      this.updateEmpty(noData);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          theme = _this$props3.theme,
          height = _this$props3.height,
          width = _this$props3.width,
          selfAdaptive = _this$props3.selfAdaptive,
          selfAdaptiveRatio = _this$props3.selfAdaptiveRatio,
          selfAdaptiveWidth = _this$props3.selfAdaptiveWidth;
      var renderedHeight = height;
      var renderedWidth = width; // 处理自适应，当小尺寸时，高度变成90%

      if (height && (selfAdaptive === 'mini' || selfAdaptive === 'small')) {
        renderedHeight = height * selfAdaptiveRatio;
      }

      if (selfAdaptiveWidth && width && (selfAdaptive === 'mini' || selfAdaptive === 'small')) {
        renderedWidth = width * selfAdaptiveRatio;
      }

      return /*#__PURE__*/React.createElement(Chart, {
        theme: theme,
        className: className
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          height: renderedHeight,
          width: renderedWidth
        },
        className: "jmtc-container",
        ref: function ref(chartRef) {
          _this3.chartRef = chartRef;
        }
      }));
    }
  }]);

  return EchartKernel;
}(PureComponent);

EchartKernel.propTypes = {
  data: PropTypes.object.isRequired,
  noData: PropTypes.bool.isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  renderer: PropTypes.string,
  tooltipRender: PropTypes.func,
  chartConfig: PropTypes.object,
  theme: PropTypes.string.isRequired,
  formatter: PropTypes.func,
  chartDidMount: PropTypes.func,
  chartLegendChange: PropTypes.func,
  selfAdaptive: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  selfAdaptiveRatio: PropTypes.number,
  isMini: PropTypes.bool,
  showDownloadImg: PropTypes.bool,
  selfAdaptiveWidth: PropTypes.bool
};
EchartKernel.defaultProps = {
  height: null,
  width: null,
  className: '',
  renderer: 'canvas',
  tooltipRender: Tooltip,
  chartConfig: {},
  formatter: undefined,
  chartDidMount: function chartDidMount() {},
  chartLegendChange: function chartLegendChange() {},
  selfAdaptive: null,
  selfAdaptiveRatio: 0.8,
  isMini: false,
  showDownloadImg: false,
  selfAdaptiveWidth: false
};

function Echart(_ref2) {
  var renderer = _ref2.renderer,
      other = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(ConfigConsumer, {
    chartRenderer: renderer
  }, function (_ref3) {
    var _ref3$chartRenderer = _ref3.chartRenderer,
        chartRenderer = _ref3$chartRenderer === void 0 ? 'canvas' : _ref3$chartRenderer,
        _ref3$chartTheme = _ref3.chartTheme,
        chartTheme = _ref3$chartTheme === void 0 ? 'default' : _ref3$chartTheme,
        jmtSelfAdaptive = _ref3.jmtSelfAdaptive,
        jmtSelfAdaptiveChartRatio = _ref3.jmtSelfAdaptiveChartRatio;
    return /*#__PURE__*/React.createElement(EchartKernel, _extends({
      key: JSON.stringify({
        chartRenderer: chartRenderer,
        chartTheme: chartTheme
      }),
      renderer: chartRenderer,
      theme: chartTheme,
      selfAdaptive: jmtSelfAdaptive,
      selfAdaptiveRatio: jmtSelfAdaptiveChartRatio
    }, other));
  });
}

Echart.propTypes = {
  data: PropTypes.object.isRequired,
  noData: PropTypes.bool.isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  renderer: PropTypes.string,
  tooltipRender: PropTypes.func,
  chartConfig: PropTypes.object,
  formatter: PropTypes.func,
  chartDidMount: PropTypes.func,
  chartLegendChange: PropTypes.func,
  isMini: PropTypes.bool,
  selfAdaptiveWidth: PropTypes.bool
};
Echart.defaultProps = {
  className: '',
  height: null,
  width: null,
  renderer: null,
  tooltipRender: Tooltip,
  chartConfig: {},
  formatter: undefined,
  chartDidMount: function chartDidMount() {},
  chartLegendChange: function chartLegendChange() {},
  isMini: false,
  selfAdaptiveWidth: false
};
export default Echart;